export const GIT_BRANCH = "master"
export const GIT_HASH = "a85bf1d76981de43d344e965a16cb34658ebe2b4"
export const BUILD_NUM = "master.2021.09.13.8"
export const THEME_COLOR = "#808080"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const APP_NAME = "Production WL Build"
export const START_URL = "https://web-order.flipdish.co/client/productionwlbuild/latest/pwa.html"
export const WHITE_LABEL_ID = "3"
